export default __webpack_public_path__ + "static/media/trash.360d7d02.svg";